// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-color {
    font-size: 25px;
    padding: 25px;
}

.margin-left {
    margin-left: 25px;
}

.input-field {
    margin-left: -3px;
    padding: 4px;
    width: 15rem;
    margin-top: -2rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: medium;
    box-sizing: border-box;
    vertical-align: middle;
}

.mt15 {
    margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/dataLoad/master_data_interfaces/L2Interfaces.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".tab-color {\n    font-size: 25px;\n    padding: 25px;\n}\n\n.margin-left {\n    margin-left: 25px;\n}\n\n.input-field {\n    margin-left: -3px;\n    padding: 4px;\n    width: 15rem;\n    margin-top: -2rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    font-size: medium;\n    box-sizing: border-box;\n    vertical-align: middle;\n}\n\n.mt15 {\n    margin-top: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
